import { CollectionRuleType, ContentType, RuleOperator, CollectionRuleResponse } from "@authory-packages/core";
import { V3COMBINED_AUDIO_TYPE, V3COMBINED_POST_TYPE, V3COMBINED_WEBSITE_EMAIL_TYPE } from "./getFormattedSourceTypes";

export const getKeywordRules = (rules: CollectionRuleResponse[]) =>
    rules.filter((rule) => rule.type === CollectionRuleType.Keyword).map((rule) => rule.params[0]);

export const getSourceRules = (rules: CollectionRuleResponse[], srcList: { label: string; value: string }[]) =>
    rules
        .filter((rule) => rule.type === CollectionRuleType.Source)
        .map((rule) => rule.params[0])
        .filter((rule) => !!srcList.find((src) => src.value === rule));

export const getTypeRules = (rules: CollectionRuleResponse[]) =>
    rules
        .filter((rule) => rule.type === CollectionRuleType.Type)
        .map((rule) => rule.params[0])
        .filter((rule) => rule !== ContentType.ReplyPost)
        .filter((rule) => rule !== ContentType.Thread)
        .filter((rule) => rule !== ContentType.ImagePost)
        .filter((rule) => rule !== ContentType.VideoPost)
        .filter((rule) => rule !== ContentType.Email)
        .filter((rule) => rule !== ContentType.Audio)
        .map((rule) => {
            if (rule === ContentType.TextPost) return V3COMBINED_POST_TYPE;
            if (rule === ContentType.Website) return V3COMBINED_WEBSITE_EMAIL_TYPE;
            if (rule === ContentType.PodcastItem) return V3COMBINED_AUDIO_TYPE;
            return rule;
        });

export const getOperatorLabel = (operator: RuleOperator) => {
    switch (operator) {
        case RuleOperator.All:
            return "AND";
        case RuleOperator.Any:
            return "OR";
    }
};
